import { ALL_STORE_SPECIALS_OPTS } from '@iheartjane/data-access';
import { useStoreSpecials } from '@iheartjane/data-access/react-query';
import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { Loading } from '@iheartjane/reefer';
import kebabCase from 'lodash-es/kebabCase';
import { Navigate, useLocation, useParams } from 'react-router';

import { useGetStoreSpecials } from '@jane/shared-ecomm/data-access';

export const MenuSpecialDetailRedirect = () => {
  const location = useLocation();
  const { store_id: storeId, special_id: specialId, slug } = useParams();
  const useV3 = useFlag(FLAGS.c3UseV3StoreSpecials);

  const v1Query = useGetStoreSpecials(storeId || 0, {
    enabled: !slug && !useV3,
  });

  const v3Query = useStoreSpecials({
    ...ALL_STORE_SPECIALS_OPTS,
    enabled: !slug && !!useV3,
    storeId: storeId || 0,
  });

  const specials = useV3
    ? (v3Query.data?.pages.flatMap((page) => page.specials) ?? [])
    : (v1Query.data ?? []);
  const isFetched = useV3 ? v3Query.isFetched : v1Query.isFetched;

  const currentPath = location.pathname.split('/specials');
  const withSlugUrl = `${currentPath[0]}/menu/specials/${currentPath[1]}`;

  if (slug) return <Navigate to={withSlugUrl} replace />;

  const currentSpecial = specials.find(
    (special) => String(special.id) === specialId
  );

  if (!isFetched) return <Loading size="lg" />;

  const specialsUrl = `${currentPath[0]}/menu/specials`;

  if (isFetched && !currentSpecial)
    return <Navigate to={specialsUrl} replace />;

  const addSlugToUrl = `${currentPath[0]}/menu/specials${
    currentPath[1]
  }/${kebabCase(currentSpecial?.title)}`;

  return <Navigate to={addSlugToUrl} replace />;
};
